import React, { Fragment } from 'react';

import { FormattedDate } from 'components/shared/Text/Text';
import DisclosureModal from '../Disclosure/DisclosureModal';
import Content from 'services/Content';

const BalanceAsOfDate = ({ balanceAsOfDate, productType }) => {
  const disclosureContent = Content.asOfDateProductDisclosure(productType);
  return (
    <Fragment>
      <FormattedDate
        format="[as of] MM/DD/YYYY"
        data-testid="balance-as-of-date-component">
        {balanceAsOfDate}
      </FormattedDate>
      <DisclosureModal
        data-testid={'as-of-date-disclosure-modal'}
        className="as-of-date-disclosure"
        content={disclosureContent}
        title="Important Information Regarding the Updating of Account Balances"
        hideLinkContent
      />
    </Fragment>
  );
};

export default BalanceAsOfDate;
